import { AbsoluteSmallButton } from "@src/appV2/redesign/components/AbsoluteSmallButton";
import { type IconButtonProps } from "@src/appV2/redesign/system/ui-components";

export function TopRightCloseButton(props: { onClick: () => void } & Partial<IconButtonProps>) {
  return <AbsoluteSmallButton iconType="close" position="right" label="Close" {...props} />;
}
